import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useMesh() {
  return useQuery({
    queryKey: ['mesh'],
    queryFn: api.mesh,
    refetchInterval: 10_000,
  });
}
